import { Avatar, Grid, GridProps } from "@mui/material";
import { customOrange } from "core/theme/variants";
import { Profile } from "core/types/social.types";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import { Text } from "components/atoms/text";

interface Props {
  profile: Profile;
}

const IgAccountInfo: FunctionComponent<Props & GridProps> = ({
  profile,
  id,
}) => {
  const { t } = useTranslation();

  return (
    <Grid container spacing={2} id={id}>
      <Grid item xs={12} sm={1}>
        {profile.profilePictureUrl ? (
          <Avatar src={profile.profilePictureUrl} alt={profile.username} />
        ) : (
          <Avatar sx={{ bgcolor: customOrange[500] }}>
            <PersonRoundedIcon
              sx={{
                color: "white",
              }}
            />
          </Avatar>
        )}
      </Grid>
      <Grid item xs={12} sm={5} display={"flex"} flexDirection={"column"}>
        <Text>@{profile.username}</Text>
        <Text variant="h4">{profile.name}</Text>
      </Grid>
      <Grid item xs={12} sm={3} display={"flex"} flexDirection={"column"}>
        <Text>
          {t("social-dashboard.account.followers") +
            " " +
            profile.followersCount}
        </Text>
        <Text>
          {t("social-dashboard.account.following") + " " + profile.followsCount}
        </Text>
      </Grid>
      <Grid item xs={12} sm={3} display={"flex"} flexDirection={"column"}>
        <Text>
          {t("social-dashboard.account.post") + " " + profile.mediaCount}
        </Text>
      </Grid>
    </Grid>
  );
};

export default IgAccountInfo;
